"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInput = void 0;
var react_1 = __importDefault(require("react"));
var FileInput = /** @class */ (function (_super) {
    __extends(FileInput, _super);
    function FileInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: ''
        };
        _this.handleFilChanged = function (e) {
            _this.setState({ value: e.target.value.split(/(\\|\/)/g).pop() });
            _this.props.onFileChanged && _this.props.onFileChanged(e);
        };
        return _this;
    }
    FileInput.prototype.render = function () {
        return (react_1.default.createElement("div", { style: { position: 'relative' } },
            react_1.default.createElement("input", { type: 'file', name: this.props.name, className: this.props.className, onChange: this.handleFilChanged, accept: this.props.accept, style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    opacity: 0,
                    padding: 0,
                    width: '100%',
                    height: '40px',
                    fontSize: '0px',
                    cursor: 'pointer',
                    zIndex: 100
                } }),
            react_1.default.createElement("input", { type: 'text', tabIndex: -1, name: this.props.name + '_filename', className: this.props.className, onChange: function () { }, placeholder: this.props.placeholder, disabled: this.props.disabled, style: {
                    position: 'absolute',
                    zIndex: -1,
                    width: '100%',
                    top: 0,
                    left: 0
                } })));
    };
    return FileInput;
}(react_1.default.Component));
exports.FileInput = FileInput;
